<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Blog</h1>
                <p>Ci sono {{ get().length }} articoli registrati nel sistema</p>
                <button type="button" class="btn btn-primary" (click)="handleModal(undefined, 'create')">Aggiungi</button>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col">
            <input type="text" class="form-control" id="filter_text" name="filter_text" placeholder="Filtro di ricerca" [(ngModel)]="filter.text">
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div [hidden]="!get().length && !filter.text" class="table-responsive-md">
                <table class="table">
                    <thead class="thead-primary">
                        <tr>
                            <th scope="col">Copertina</th>
                            <th scope="col">Titolo</th>
                            <th scope="col">Paragrafi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="cursor-pointer" (click)="handleModal(blog.public_token, 'update')" *ngFor="let blog of get(); index as i">
                            <td scope="col"><img style="max-width: 150px;" [src]="window.flowup.utils.getPicture(blog.configuration?.cover?.name)" /></td>
                            <td scope="col">{{ blog.configuration?.title }}</td>
                            <td scope="col">{{ blog.configuration?.paragrafi?.length || 0 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<span id="blogModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Aggiungi</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-row">
                            <div class="form-group col-12 text-center">
                                <label for="blog_cover" class="cursor-pointer underline-hover">Inserisci la cover +</label>
                                <input hidden type="file" class="form-control" id="blog_cover" name="blog_cover" (change)="getCover($event)">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12">
                                <img class="w-100" [src]="window.flowup.utils.getPicture(getBlog().configuration?.cover?.name)" alt="">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <input type="text" class="form-control" name="title" placeholder="Titolo del blog" [(ngModel)]="getBlog().configuration.title">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-12">
                                <input type="text" class="form-control" name="subtitle" placeholder="Sottotitolo del blog" [(ngModel)]="getBlog().configuration.subtitle">
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-12"><hr></div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-10">
                                <input type="text" class="form-control" name="tag" placeholder="Tags del blog" [(ngModel)]="tag">
                            </div>
                            <div class="form-group col-md-2 p-0">
                                <button class="btn btn-primary float-right" (click)="addTag()">Aggiungi</button>
                            </div>
                        </div>
                        <div class="form-row">
                            <ul class="w-100">
                                <li *ngFor="let t of getBlog().configuration.tags; let j = index" class="text-capitalize mb-3">{{ t }} <button class="btn btn-danger float-right" (click)="getBlog().configuration.tags.splice(j, 1)"><i class="fa fa-trash"></i></button></li>
                            </ul>
                        </div>
                        
                        <div class="row">
                            <div class="col-12"><hr></div>
                        </div>

                        <h5 class="cursor-pointer underline-hover mt-3" (click)="openParagrafoModal()">Aggiungi Paragrafo <i class="fa fa-plus"></i></h5>
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive-md">
                                    <table class="table">
                                        <thead class="thead-primary">
                                            <tr>
                                                <th scope="col">Titolo</th>
                                                <th scope="col">Descrizione</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="cursor-pointer" *ngFor="let paragrafo of getBlog().configuration?.paragrafi; index as i" (click)="openParagrafoModal(paragrafo)">
                                                <td scope="col">{{ paragrafo.title }}</td>
                                                <td scope="col" [innerHtml]="paragrafo.description"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <app-related-blog [blog]="getBlog()"></app-related-blog>
                        <!--<h5 class="cursor-pointer underline-hover mt-3" (click)="openRelatedModal()">Aggiungi Oggetto di riferimento <i class="fa fa-plus"></i></h5>
                        <div class="row">
                            <div class="col">
                                <div class="table-responsive-md">
                                    <table class="table">
                                        <thead class="thead-primary">
                                            <tr>
                                                <th scope="col">Titolo</th>
                                                <th scope="col">Descrizione</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="cursor-pointer" *ngFor="let paragrafo of getBlog().configuration?.related_objects; index as i">
                                                <td scope="col">{{ paragrafo.title }}</td>
                                                <td scope="col">{{ paragrafo.description }}</td>
                                                <td scope="col"><button class="btn btn-danger" (click)="openParagrafoDeleteModal()"><i class="fa fa-trash"></i></button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>-->
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-primary" (click)="handleBlog()">{{ !!getBlog().public_token ? 'Aggiorna' : 'Aggiungi' }}</button>
                    <button type="button" class="btn btn-outline-danger" (click)="handleModal(getBlog().public_token, 'delete')" [hidden]="!getBlog().public_token">Elimina</button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteBlogModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Conferma</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(getBlog().public_token, 'update')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                Sei sicuro di voler eliminare questo articolo del Blog?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="deleteBlog()">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(getBlog().public_token, 'update')">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="paragrafoModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog" style="overflow-y: scroll;">
        <div class="modal-dialog modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Paragrafo</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeParagrafoModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <input type="text" class="form-control" name="paragrafo_title" placeholder="Titolo del paragrafo" [(ngModel)]="paragrafo_model.title">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <ckeditor [editor]="Editor" [(ngModel)]="paragrafo_model.description" name="paragrafo_description" id="paragrafo_description"></ckeditor>
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary" (click)="handleParagrafo()">{{ !!paragrafo_model.id ? 'Aggiorna' : 'Aggiungi' }}</button>
                <button type="button" class="btn btn-outline-danger float-left" (click)="openParagrafoDeleteModal(paragrafo_model)" [hidden]="!paragrafo_model.id">Elimina</button>
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="closeParagrafoModal()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>

<span id="deleteParagrafoModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Conferma</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeParagrafoDeleteModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                Sei sicuro di voler eliminare questo paragrafo?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" (click)="deleteParagrafo()">Elimina</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeParagrafoDeleteModal()">Chiudi</button>
            </div>
          </div>
        </div>
    </div>
</span>